import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import '../GridStyleOverrides/materialTableHome.css'
import { SET_PLAN_MANAGE_SEARCH, SET_PLAN_DATA_ROW } from '../../actions/types';
import { BiDriverService, BiDropdownService, BiPlanningService } from "../../services";
import { Typography } from "../../components/controls";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { Checkbox, InputLabel, Backdrop, Box, Button, Card, CardContent, CircularProgress, Container, Grid, IconButton, TextareaAutosize, TextField, Tooltip, useMediaQuery, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { HelpCircleOutline, TrashCan, ArrowExpandHorizontal, ArrowCollapseHorizontal, ClipboardText, Login, Logout, DoNotDisturb } from "mdi-material-ui";
import { red, green } from '@material-ui/core/colors';
import allowAction from '../../helpers/allowAction';
import _ from 'lodash';
import MaterialTable, { MTableToolbar } from 'material-table'
import TableIcons from '../../materialTableIcons';
import { HtmlTooltip } from '../../components/controls';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import { toStringTime, toStringDate, toStringDateTimeExternal, convertTime2Date, convertDate2Date } from './../../helpers/date';
import { ConfirmDialog, WarnDialog } from "../../components/shared";
import { CheckBox as IconCheckBox, CheckBoxOutlineBlank as IconCheckBoxBlank } from '@material-ui/icons';

const pageCode = "601";

const headerStyle = {
    backgroundColor: '#86C1D4',
    color: 'white',
    height: 49,
    textTransform: 'uppercase',
}

const rowStyle = {
    maxHeight: 50,
}

const filterOptions = createFilterOptions();

export default function PlanManagement(props) {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();

    const isTransporter = JSON.parse(localStorage.getItem('user'))?.isTransporter === 'T';

    // Loading
    const [isLoading, setIsLoading] = useState(true);

    // page form
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [searchFormData, setSearchFormData] = useState({ ...useSelector((state) => state.planManagement.manageSearch) });
    const [ddlPlant, setDdlPlant] = useState([]);
    const [ddlProduct, setDdlProduct] = useState([]);
    const [ddlTransport, setDdlTransport] = useState([]);
    const [displayMode, setDisplayMode] = useState(null);
    const [exportButton, setExportButton] = useState(false);
    const [disabledButtonSwitchMode, setDisabledButtonSwitchMode] = useState(0);
    const [fetchItem, setFetchItem] = useState([]);
    const [tableData, setTableData] = useState({
        visibility: 'hidden', sort: { field: '', sort: '' }, options: {
            selection: !isTransporter,
            filtering: false,
            search: false,
            sorting: false,
            headerStyle: headerStyle,
            rowStyle: rowStyle,
            maxBodyHeight: '600px',
            showTitle: false,
            toolbar: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: true,
            pageSizeOptions: [10, 20, 50],
            rowStyle: (r) => {
                return { color: r.fastTrack ? 'red' : (r.createType === 'IMPORT' || r.createType === 'IMPORT-AUTO' ? 'black' : 'blue') }
            }
        } });
    //selected rows
    const [selectedRows, setSelectedRows] = useState([]);
    //page form edit
    const [ddlDriver, setDdlDriver] = useState([]);
    const [ddlTruck, setDdlTruck] = useState([]);
    //import form
    const [importFormData, setImportFormData] = useState({ isOpen: false, isLoading: false, text: '', date: null, plant: null, type: 'LOAD' });
    //driver form
    const [adHocDriver, setAdHocDriver] = useState({ isOpen: false, isLoading: false, name: null, phone: null, transport: null });
    const [affectedDriver, setAffectedDriver] = useState({});
    //
    useEffect(() => {
        //Retreive dropdown
        BiDropdownService.getPlant().then((r) => {
            if (r) {
                handleSearchPlantChange(searchFormData.plant ?? (r.length > 0 ? r[0] : null))
                setDdlPlant(r)
            } else {
                setWarnDialog({
                    isOpen: true,
                    title: `Warning`,
                    subTitle: <><Box component="div">Not Found Plant.</Box></>,
                })
                setIsLoading(false);
            }
        });
        if (searchFormData.search.submit)
            setSearchFormData({ ...searchFormData, date: searchFormData.search.date, plant: searchFormData.search.plant, product: searchFormData.search.product, transport: searchFormData.search.transport, type: searchFormData.search.type, hasChange: true })
    }, []);
    useEffect(() => {
        let plant = searchFormData.plant ?? (ddlPlant.length > 0 ? ddlPlant[0] : null);
        setSearchFormData({ ...searchFormData, plant: plant, hasChange: true, search: { ...searchFormData.search, plant: searchFormData.search.plant ?? plant} })
        setImportFormData({ ...importFormData, plant: importFormData.plant ?? (ddlPlant.length > 0 ? ddlPlant[0] : null) })
    }, [ddlPlant]);
    useEffect(async () => {
        if (searchFormData.hasChange && searchFormData.plant) {
            setIsLoading(true);
            let response = await BiPlanningService.getList(searchFormData.date, searchFormData.plant?.value, searchFormData.product?.value, searchFormData.transport?.value, searchFormData.type)
            if (response) {
                const rs = response.map(item => {
                    var dnl = (item.driverId && item.hasLine === false ? '# ' : '') + (item.driverName ?? '') + (item.driverPhone ? ` (${item.driverPhone})` : '');
                    return { ...item, driverNameWithLine: dnl };
                });
                setFetchItem(rs);
            }
            setSearchFormData({ ...searchFormData, hasChange: false })
            setTableData({ ...tableData, visibility: 'visible' });
            setIsLoading(false);
        }
    }, [searchFormData]);

    const handleSearchPlantChange = (newValue) => {
        if (newValue) {
            handleDdlChange(newValue, 'plant', searchFormData, setSearchFormData, true)
            let plant = newValue.value
            BiDropdownService.getProduct(plant).then((r) => setDdlProduct(r));
            BiDropdownService.getTransport(plant, null, null).then((r) => setDdlTransport(r));
            BiDropdownService.getDriver(plant, null, null).then((r) => setDdlDriver(r));
            BiDropdownService.getTruck(plant, null, null).then((r) => setDdlTruck(r));
            dispatch({
                type: SET_PLAN_MANAGE_SEARCH,
                payload: { ...searchFormData },
            });
        }
    }
    const handleSearchTypeChange = (e) => {
        let type = searchFormData.type
        if (e.target.checked) {
            type = null;
        } else {
            type = e.target.name === 'LOAD' ? 'UNLOAD' : 'LOAD' //inverse
        }
        setSearchFormData({ ...searchFormData, type: type })
    }

    /// begin: plan search
    //dropdown
    const handleDdlChange = (val, field, target, setTarget, reset) => {
        if (val) {
            var value = val.value ?? ''
            var text = val.text ?? ''
            if (reset && field === 'plant')
                setTarget({ ...target, [field]: { text: text, value: value }, transport: null });
            else
                setTarget({ ...target, [field]: { text: text, value: value } });
        } else {
            if (field !== 'plant')
                setTarget({ ...target, [field]: null });
        }
    };
    //date
    const handleDateChange = (date, field, target, setTarget) => {
        setTarget({ ...target, [field]: toStringDateTimeExternal(date) });
    };
    //search
    const handleSearchSubmit = () => {
        setSearchFormData({ ...searchFormData, search: { ...searchFormData.search, submit: true, date: searchFormData.date, plant: searchFormData.plant, product: searchFormData.product, transport: searchFormData.transport, type: searchFormData.type }, hasChange: true });
        dispatch({
            type: SET_PLAN_MANAGE_SEARCH,
            payload: { ...searchFormData },
        });
        setTableData({ ...tableData, visibility: 'visible', sort: { field: '', sort: '' } })
    };
    /// end: plan search

    /// begin: button
    //handle switch mode
    const handleSwitchMode = () => {
        let sec = 5/*seconds*/
        setDisabledButtonSwitchMode(sec)
        for (var i = sec - 1; i >= 0; i--) {
            setTimeout(s => setDisabledButtonSwitchMode(s), (sec - i) * 1000/* miliseconds */, i);
            console.log(sec - i)
        }
        setDisplayMode(displayMode === 'READ_ONLY' ? null : 'READ_ONLY');
        setTableData({ ...tableData, options: { ...tableData.options, selection: isTransporter ? false : !tableData.options.selection, toolbar: !tableData.options.toolbar } });
    }
    //handle export file
    const handleExportPlan = async () => {
        setExportButton(true);
        await BiPlanningService.exportList(searchFormData.search.date, searchFormData.search.plant?.value, searchFormData.search.product?.value, searchFormData.search.transport?.value, searchFormData.search.type)
        setExportButton(false);
    }
    //Add New Driver
    const handleNewDriver = () => {
        setAdHocDriver({ ...adHocDriver, isOpen: true, name: null, phone: null, transport: ddlTransport.length > 0 ? ddlTransport[0] : null });
    }
    //handle import data
    const handleImportData = () => {
        setImportFormData({ ...importFormData, text: '', plant: searchFormData.plant, date: searchFormData.date, type: 'LOAD', isOpen: true, isLoading: false });
    }
    //Create new plan
    const handleCreateAction = () => {
        dispatch({
            type: SET_PLAN_DATA_ROW,
            payload: {
                planId: null,
                ticketId: null,
                state: 'PREPARE',
                status: 'PLAN',
                date: toStringDateTimeExternal(new Date(new Date().setHours(0, 0, 0, 0)))/*today*/,
                plant: ddlPlant.length > 0 ? ddlPlant[0].value : null,
                customerSupplier: null,
                volume: null,
                unit: 'LITERS',
                batchNo: null,
                transportId: '',
                transportName: '',
                product: '',
                materialNo: '',
                source: null,
                destination: null,
                from: null,
                to: null,
                so: null,
                do: null,
                po: null,
                mode: 'LOAD',
                density: null,
                truckNo: '',
                driverId: '',
                driverName: '',
                driverPhone: '',
                bookTime: null,
                type: 'NORMAL',
                referencePlanId: '',
                remark: null,
                queueTime: null,
                area: null,
                point: null,
                arm: null,
                createBy: null,
                createDate: null,
                modifyBy: null,
                modifyDate: null,
                actualStartDate: null,
                actualCompletedDate: null,
                fastTrack: null,
                createType: 'MANUAL',
                backTo: 'management',
                hasLine: null
            },
        })
        history.push('/planning/plan-management/create');
    }
    //handle delete selected rows
    const handleDeleteSelected = () => {
        setIsLoading(true);
        if (selectedRows.length > 0) {
            let plans = [];
            let tickets = '';
            let finishedTickets = '';
            selectedRows.forEach((item) => {
                plans = [...plans, item.planId]
                tickets = `${tickets}, ${item.ticketId}`
                if (item.state === 'FINISHED')
                    finishedTickets = `${finishedTickets}, ${item.ticketId}`
            });
            if (finishedTickets.length > 0)
                setWarnDialog({
                    isOpen: true,
                    title: `Warning`,
                    subTitle: <><Box component="div">Can't delete finished tickets {finishedTickets.substring(2)}</Box></>,
                })
            else
                setConfirmDialog({
                    isOpen: true,
                    title: `Confirm`,
                    subTitle: <><Box component="div">{`Are you sure you want to delete ${selectedRows.length} tickets ${tickets.substring(2)} ?`}</Box></>,
                    onConfirm: () => {
                        BiPlanningService.removePlans(plans).then((r) => {
                            if (r) {
                                let ticketSuccess = ''
                                let ticketError = ''
                                r.map(v => {
                                    if (v.status === 200) {
                                        ticketSuccess = `${ticketSuccess}, ${v.ticketId}`
                                    } else {
                                        ticketError = `${ticketError}, ${v.ticketId}`
                                    }
                                })
                                if (ticketError) {
                                    ticketError = ticketError.substr(2);
                                    let msg = '';
                                    if (ticketSuccess) {
                                        ticketSuccess = ticketSuccess.substr(2);
                                        msg = `${msg}${ticketSuccess} was delete, but `
                                    }
                                    msg = `${msg}${ticketError} can't delete.`
                                    setWarnDialog({
                                        isOpen: true,
                                        title: `Warning`,
                                        subTitle: <><Box component="div">{msg}</Box></>,
                                    })
                                }
                                if (ticketSuccess || !ticketError)
                                    setSearchFormData({ ...searchFormData, hasChange: true })
                            }
                        });
                        setConfirmDialog({ isOpen: false });
                    }
                })
        } else {
            setWarnDialog({
                isOpen: true,
                title: `Warning`,
                subTitle: <><Box component="div">Please select</Box></>,
            })
        }
        setIsLoading(false);
    };
    /// end: button

    const handleSaveAdHocDriver = () => {
        setAdHocDriver({ ...adHocDriver, isLoading: true });
        if (!(adHocDriver.name && adHocDriver.phone && adHocDriver.transport?.value)) {
            setWarnDialog({
                isOpen: true,
                title: `Required`,
                subTitle: <><Box component="div">Please input value</Box></>,
            })
        } else {
            BiDriverService.saveAdHoc(adHocDriver.name, adHocDriver.phone, adHocDriver.transport?.value).then((r) => {
                if (r) {
                    setDdlDriver([...ddlDriver, { value: r.driverId, text: r.name, name: adHocDriver.transport?.value, hasLine: false, driverPhone: adHocDriver.phone }]);
                    setAdHocDriver({ ...adHocDriver, isOpen: false });
                    let names = Object.keys(affectedDriver);
                    names.map((editData) => {
                        affectedDriver[editData](r);
                        delete affectedDriver[editData];
                        setAffectedDriver({ ...affectedDriver });
                    });
                }
            });
        }
        setAdHocDriver({ ...adHocDriver, isLoading: false });
    }
    const handleImportDataSubmit = () => {
        if (importFormData.plant?.value && importFormData.date && importFormData.type && importFormData.text) {
            setImportFormData({ ...importFormData, isLoading: true });
            BiPlanningService.importByText(importFormData.plant?.value, importFormData.date, importFormData.type, importFormData.text).then((r) => {
                if (r) {
                    if (r.message)
                        setWarnDialog({
                            isOpen: true,
                            title: `Information`,
                            subTitle: <><Box component="div">{r.message}</Box></>,
                        })
                    if (importFormData.date === searchFormData.date)
                        handleSearchSubmit()
                }
                setImportFormData({ ...importFormData, isLoading: false, isOpen: false });
            })
        } else {
            setWarnDialog({
                isOpen: true,
                title: `Warning`,
                subTitle: <><Box component="div">Please fill your data.</Box></>,
            })
        }
    }
    const handleDownloadTemplate = async () => {
        //setWarnDialog({
        //    isOpen: true,
        //    title: `Coming soon`,
        //    subTitle: <><Box component="div">Under development</Box></>,
        //})
        await BiPlanningService.downloadTemplateUpload(importFormData.type)
    }
    const handleBulkSavePlans = async (changes, resolve, reject) => {
        if (changes) {
            let pass = '';
            let rows = [];
            Object.keys(changes).map((editData) => {
                let oldData = changes[editData]['oldData'];
                let newData = changes[editData]['newData'];

                let newTime = newData.bookTime;
                let newDriver = newData.driverId;
                let newTruck = newData.truckNo;
                let newPO = newData.po;

                if (!(newTime && newDriver && newTruck) && (newTime || newDriver || newTruck)) {
                    pass = `${pass}, ${oldData.ticketId}`;
                }

                rows = [...rows, {
                    planId: oldData.planId,
                    ticketId: oldData.ticketId,
                    truckNo: newTruck,
                    driverId: newDriver,
                    bookTime: newTime,
                    po: newPO
                }];
            });
            if (pass) {
                setWarnDialog({
                    isOpen: true,
                    title: `Warning`,
                    subTitle: <><Box component="div">Some information of {pass.substr(2)} is incorrect.</Box></>,
                })
                reject()
            } else if (rows.length > 0) {
                var r = await BiPlanningService.savePlanningList(rows)
                if (r) {
                    let success = false;
                    let pass = true;
                    let msg = '';
                    for (let i = 0; i < r.length; i++) {
                        if (r[i].status === 200)
                            success = true;
                        else
                            pass = false
                        if (r[i].content)
                            msg = `${msg}, '${r[i].ticketId}': ${r[i].content}`;
                    }
                    if (msg) {
                        msg = msg.substr(2);
                        setWarnDialog({
                            isOpen: true,
                            title: `Warning`,
                            subTitle: <><Box component="div" style={{ whiteSpace: "pre-wrap" }}>{msg}</Box></>,
                        })
                        if (!pass)
                            reject()
                    }
                    if (success)
                        setSearchFormData({ ...searchFormData, hasChange: true })
                }
            }
        }
        resolve()
    }
    const handleRemovePlan = (rowData) => {
        setIsLoading(true);
        if (rowData.state === 'FINISHED')
            setWarnDialog({
                isOpen: true,
                title: `Warning`,
                subTitle: <><Box component="div">Can't delete tickets {rowData.ticketId}</Box></>,
            })
        else
            setConfirmDialog({
                isOpen: true,
                title: `Confirm`,
                subTitle: <><Box component="div">{`Are you sure you want to delete ticket ${rowData.ticketId} ?`}</Box></>,
                onConfirm: () => {
                    BiPlanningService.removePlan(rowData.planId).then((r) => {
                        if (r) {
                            if (r.status === 200)
                                setSearchFormData({ ...searchFormData, hasChange: true })
                            else {
                                setWarnDialog({
                                    isOpen: true,
                                    title: `Warning`,
                                    subTitle: <><Box component="div">Can't delete tickets {r[0].ticketId}</Box></>,
                                })
                            }
                        }
                    });
                    setConfirmDialog({ isOpen: false });
                }
            })
        setIsLoading(false);
    }
    const handlePlanDetail = (rowData) => {
        BiPlanningService.getPlanDetail(rowData.planId).then(r => {
            if (r) {
                dispatch({
                    type: SET_PLAN_DATA_ROW,
                    payload: { ...r, backTo: 'management' },
                });
                history.push('/planning/plan-management/create');
            }
        })
    }
    const handleCopyPlan = (rowData) => {
        BiPlanningService.getPlanDetail(rowData.planId).then(r => {
            if (r) {
                dispatch({
                    type: SET_PLAN_DATA_ROW,
                    payload: {
                        ...r,
                        ticketId: null,
                        planId: null,
                        state: 'PREPARE',
                        status: 'PLAN',
                        date: toStringDateTimeExternal(new Date(new Date().setHours(0, 0, 0, 0)))/*today*/,
                        bookTime: null,
                        queueTime: null,
                        //area: null,
                        //point: null,
                        //arm: null,
                        createBy: null,
                        createDate: null,
                        modifyBy: null,
                        modifyDate: null,
                        actualStartDate: null,
                        actualCompletedDate: null,
                        fastTrack: null,
                        createType: 'COPY',
                        backTo: 'management'
                    },
                });
                history.push('/planning/plan-management/create');
            }
        })
    }
    const handleFastTrack = (rowData) => {
        setConfirmDialog({
            isOpen: true,
            title: `Confirm`,
            subTitle: <>
                <Box component="div">
                    {`Are you sure you want to change fast track '${(rowData.fastTrack ? 'OFF' : 'ON')}' to ticket ${rowData.ticketId} ?`}
                    {rowData.state === 'QUEUE' && rowData.status !== 'CHECK-IN' ? <><br />{`Status will auto change to 'CHECK-IN'.`}</> : <></>}
                </Box>
            </>,
            onConfirm: () => {
                let fastTrack = rowData.fastTrack ? null : toStringDateTimeExternal(new Date());
                BiPlanningService.setFastTrack(rowData.planId, fastTrack).then(r => {
                    if (r) {
                        const rs = fetchItem.map(item => {
                            var dnl = (item.driverId && item.hasLine === false ? '# ' : '') + (item.driverName ?? '') + (item.driverPhone ? ` (${item.driverPhone})` : '');
                            if (item.planId === rowData.planId)
                                return fastTrack ? { ...item, fastTrack: fastTrack, status: 'CHECK-IN', driverNameWithLine: dnl } : { ...item, fastTrack: fastTrack, driverNameWithLine: dnl };
                            else
                                return { ...item, driverNameWithLine: dnl };
                        });
                        setFetchItem(rs);
                    }
                });
                setConfirmDialog({ isOpen: false });
            }
        })
    }
    const handleCheckInCheckOut = (rowData, state) => {
        if (state === null) {
            setWarnDialog({
                isOpen: true,
                title: `Warning`,
                subTitle: <><Box component="div">Can't Check-In/Check-Out ticket {rowData.ticketId} ({rowData.status}/{rowData.state})</Box></>,
            })
        } else {
            let times = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];//minutes
            setConfirmDialog({
                isOpen: true,
                title: `Confirm`,
                subTitle: <>
                    <Box component="div">
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                {`Are you sure you want to '${state}' ticket ${rowData.ticketId} ?`}
                            </Grid>
                            {
                                state === 'CHECK-IN' ? <>
                                        <Grid item xs={12} sm={12} md={8} lg={8}>
                                            {`Please choose time for drive to plant after call,`}
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={2} lg={2}>
                                            <select name="checkInTime" id="checkInTime" class="MuiInputBase-root" style={{ width: '100%' }}>
                                                {times.map(v => { return <option class="MuiInputBase-root" value={v}>{v}</option> })}
                                            </select>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={2} lg={2}>
                                            {`minutes`}
                                        </Grid>
                                </> : <></>
                            }
                        </Grid>
                    </Box>
                </>,
                onConfirm: async () => {
                    let r = state === 'CHECK-IN' ? await BiPlanningService.checkInPlan(rowData.planId, document.querySelector('#checkInTime')?.value) : await BiPlanningService.checkOutPlan(rowData.planId);
                    if (r?.status === 200) {
                        const rs = fetchItem.map(item => {
                            var dnl = (item.driverId && item.hasLine === false ? '# ' : '') + (item.driverName ?? '') + (item.driverPhone ? ` (${item.driverPhone})` : '');
                            if (item.planId === rowData.planId)
                                return { ...item, status: state, driverNameWithLine: dnl };
                            else
                                return { ...item, driverNameWithLine: dnl };
                        });
                        setFetchItem(rs);
                    } else {
                        setWarnDialog({
                            isOpen: true,
                            title: `Warning`,
                            subTitle: <><Box component="div">Please check your book time first. {rowData.ticketId} ({rowData.status}/{rowData.state})</Box></>,
                        })
                    }
                    setConfirmDialog({ isOpen: false });
                }
            });
        }
    }

    //handle Expand/Collapse Grid
    const isLargeDisplay = useMediaQuery('(min-width: 1500px)');
    ////use this to change container props. setting to {maxWidth: false} allows grid to expand full width
    const [containerProps, setContainerProps] = useState('');
    ////Grid Actions toolip
    ////...need these things to get better control of toolip or else it lingers on expand and collapse
    const [openTooltip, setOpenTooltip] = useState(false)
    const handleShowTooltip = () => {
        setOpenTooltip(true)
    }
    const handleHideTooltip = () => {
        setOpenTooltip(false)
    }
    const disabledEditing = (rowData, value, name) => {
        ////if (rowData.state === 'FINISHED' || rowData.state === 'PROCESS' || (rowData.state === 'QUEUE' && (rowData.status === 'CONFIRMED' || rowData.status === 'CALL' || rowData.status === 'CHECK-IN')))
        //if (!((rowData.state === 'PREPARE' && (rowData.status === 'OPEN' || rowData.status === 'DEFER')) || (rowData.state === 'QUEUE' && (rowData.status === 'TIMEOUT' || rowData.status === 'REJECTED'))))
        //    return (<TextField style={{ width: 150, minWidth: 130, maxWidth: 180 }} value={value} disabled={true} label={name} InputLabelProps={{ shrink: true }}></TextField>);
        return null
    }

    const callFilterOptions = React.useCallback((options, params) => {
        const filtered = filterOptions(options.filter(x => Object.keys(x).filter(n => n !== 'name').length > 0), params);
        if (params.inputValue !== '') {
            filtered.push({
                inputValue: params.inputValue,
                text: `Add "${params.inputValue}"`,
            });
        }
        return filtered;
    }, []);
    const callGetOptionLabel = React.useCallback((option) => {
        if (typeof option === 'string') {
            return option;
        }
        if (option.inputValue) {
            return option.inputValue;
        }
        if (option.hasLine === false) {
            return `# ${option.text ?? ''}` + (option.driverPhone ? ` (${option.driverPhone})` : '') + (option.driverPhone ? ` (${option.driverPhone})` : '')
        }
        return option.text + (option.driverPhone ? ` (${option.driverPhone})` : '') + (option.driverPhone ? ` (${option.driverPhone})` : '');
    }, []);

    const getTooltipData = (data, len) => {
        if (!len || len < 0) {
            len = 20
        }
        if (data && typeof data === 'string') {
            if (data.length > len) {
                return (<Box component="span" title={data}>{data.substr(0, len - 3)}...</Box>)
            }
        }
        return (<Box component="span" title={data}>{data}</Box>)
    }

    const actions = [
        {
            name: 'edit',
            icon: () => <TableIcons.Edit />,
            tooltip: isTransporter ? 'Detail' : 'Edit Plan',
            onClick: (event, rowData) => handlePlanDetail(rowData),
            disabled: false,
            position: "row"
        },
        {
            name: 'copy',
            icon: () => <ClipboardText />,
            tooltip: 'Copy Plan',
            onClick: (event, rowData) => handleCopyPlan(rowData),
            disabled: isTransporter,
            hidden: isTransporter,
            position: "row"
        },
        {
            name: 'remove', // Added custom name property so we know which action to check for
            icon: () => <TrashCan />,
            tooltip: 'Delete Plan',
            onClick: (event, rowData) => handleRemovePlan(rowData),
            disabled: isTransporter,
            hidden: isTransporter,
            position: "row"
        },
    ]

    const columns = useMemo(() =>
        [
            {
                title: 'I/O', tooltip: `Check In / Check Out`, //editable: 'never', hidden: !isTransporter,
                editComponent: () => (<></>),
                render: (rowData) => {
                    let state = rowData.state === 'QUEUE' && (rowData.status === 'PENDING' || rowData.status === 'CHECK-OUT') ? 'CHECK-IN' : (rowData.state === 'QUEUE' && rowData.status === 'CHECK-IN' ? 'CHECK-OUT' : null)
                    return (<Box component="span" style={{ 'padding': 'unset', 'color': 'black' }} onClick={() => handleCheckInCheckOut(rowData, state)} disabled={!state} title={state} >
                            {state === null ? <DoNotDisturb /> : (state === 'CHECK-IN' ? <Login /> : <Logout />)}
                    </Box>)
                }
            },
            {
                title: 'FT', hidden: isTransporter, tooltip: `Fast Track`, //editable: 'never',
                editComponent: () => (<></>),
                render: (rowData) => {
                    return (<Box component="span" style={{ 'padding': 'unset', 'display': isTransporter ? 'none' : 'flex', 'color': 'black' }} onClick={() => handleFastTrack(rowData)} title={`Fast Track ${(rowData.fastTrack ? 'ON' : 'OFF')}`} >
                        {rowData.fastTrack ? <IconCheckBox /> : <IconCheckBoxBlank />}
                    </Box>)
                }
            },
            { title: 'PRODUCT', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, editable: 'never', render: r => getTooltipData(r.product) },
            { title: 'CUSTOMER', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, editable: 'never', render: r => getTooltipData(r.customer) },
            { title: 'SRC/DEST', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, tooltip: `Source / Destination`, editable: 'never', render: r => getTooltipData(r.plan === 'Load' ? r.destination : r.source) },
            { title: 'TRANSPORTER', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, editable: 'never', render: r => getTooltipData(r.transporter) },
            {
                title: 'TRUCK', field: 'truckNo',// render: r => getTooltipData(r.truckNo),
                editComponent: (props) => {
                    return disabledEditing(props.rowData, props.value, 'Truck No') ?? (
                        <Autocomplete style={{ width: 150, minWidth: 130, maxWidth: 180 }}
                            filterOptions={callFilterOptions}
                            getOptionLabel={callGetOptionLabel}
                            onChange={(event, newValue) => {
                                let isAlert = true;
                                let testFormat = v => /^((.{2}\.\d{2,3}-\d{4}(\/((.{2}\.)?\d{2,3}-)\d{4})?)|(.{2}\.\d{0,1}.{2}\d{1,4}))$/.test(v);
                                if (typeof newValue === 'string') {
                                    if (testFormat(newValue.trim())) {
                                        isAlert = false;
                                        setTimeout(() => {
                                            props.onChange(newValue.trim());
                                            //to do : insert new truck
                                            setDdlTruck([...ddlTruck, { text: newValue.trim(), value: newValue.trim(), name: props.rowData.transportId }]);
                                        });
                                    }
                                } else if (newValue && newValue.inputValue) {
                                    if (testFormat(newValue.inputValue.trim())) {
                                        isAlert = false;
                                        props.onChange(newValue.inputValue.trim());
                                        //to do : insert new truck
                                        setDdlTruck([...ddlTruck, { text: newValue.inputValue.trim(), value: newValue.inputValue.trim(), name: props.rowData.transportId }]);
                                    }
                                } else {
                                    isAlert = false;
                                    props.onChange(newValue ? newValue.value : '');
                                }
                                if (isAlert) {
                                    setWarnDialog({
                                        isOpen: true,
                                        title: `Warning`,
                                        subTitle: <><Box component="div">Invalid Truck No : [หัว] กก.12-1234 หรือ [หัว/หาง] กก.12-1234/98-7654, กก.12-1234/กก.98-7654 หรือ [กระบะ] กก.1กก1234</Box></>,
                                    });
                                }
                            }}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            id="editTruckNo"
                            name="editTruckNo"
                            options={ddlTruck.filter(v => v.name === props.rowData.transportId)}
                            value={props.value ? { text: props.value, value: props.value, name: props.rowData.transportId } : null}
                            renderOption={option => <>{option?.text}</>}
                            renderInput={(params) => <TextField {...params}
                                id="editTruckNoText"
                                name="editTruckNoText"
                                label="Truck No"
                                size="small"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                            />}
                        />
                    );
                },
            },
            {
                title: 'DRIVER',// field: 'driverName',//render: r => getTooltipData(r.driverName),
                field: 'driverNameWithLine',
                editComponent: (props) => {
                    return disabledEditing(props.rowData, props.value, 'Driver Name') ?? (
                        <Autocomplete style={{ width: 170, minWidth: 130, maxWidth: 180 }}
                            filterOptions={callFilterOptions}
                            getOptionLabel={callGetOptionLabel}
                            onChange={(event, newValue) => {
                                if (typeof newValue === 'string') {
                                    if (newValue.trim().length > 4 && newValue.trim().length <= 50) {
                                        setTimeout(() => {
                                            setAdHocDriver({ ...adHocDriver, isOpen: true, name: newValue, phone: '', transport: { text: props.rowData.transporter, value: props.rowData.transportId } });
                                            setAffectedDriver({
                                                ...affectedDriver,
                                                [props.rowData.planId]: (driver) => {
                                                    props.onRowDataChange({ ...props.rowData, driverName: driver ? driver.name : '', driverId: driver ? driver.driverId : '', hasLine: driver?.hasLine ?? false });
                                                }
                                            });
                                        });
                                    } else {
                                        setWarnDialog({
                                            isOpen: true,
                                            title: `Warning`,
                                            subTitle: <><Box component="div">Driver Name too short/long</Box></>,
                                        });
                                    }
                                } else if (newValue && newValue.inputValue) {
                                    if (newValue.inputValue.trim().length > 4 && newValue.inputValue.trim().length <= 50) {
                                        setAdHocDriver({ ...adHocDriver, isOpen: true, name: newValue.inputValue, phone: '', transport: { text: props.rowData.transporter, value: props.rowData.transportId } });
                                        setAffectedDriver({
                                            ...affectedDriver,
                                            [props.rowData.planId]: (driver) => {
                                                props.onRowDataChange({ ...props.rowData, driverName: driver ? driver.name : '', driverId: driver ? driver.driverId : '', hasLine: driver?.hasLine ?? false });
                                            }
                                        });
                                    } else {
                                        setWarnDialog({
                                            isOpen: true,
                                            title: `Warning`,
                                            subTitle: <><Box component="div">Driver Name too short/long</Box></>,
                                        });
                                    }
                                } else {
                                    props.onRowDataChange({ ...props.rowData, driverName: newValue ? newValue.text : '', driverId: newValue ? newValue.value : '', hasLine: newValue?.hasLine ?? false });
                                    let target = newValue;
                                    if (target !== null) {
                                        let nextMonth = new Date();
                                        nextMonth.setMonth(nextMonth.getMonth() + 1);
                                        let msg = '';
                                        if (target.licenseExpire && new Date(target.licenseExpire) <= nextMonth)
                                            msg = `${msg} and licence (${toStringDate(target.licenseExpire)})`;
                                        if (target.trainingExpire && new Date(target.trainingExpire) <= nextMonth)
                                            msg = `${msg} and training (${toStringDate(target.licenseExpire)})`;
                                        if (msg) {
                                            msg = msg.substr(5);
                                            setWarnDialog({
                                                isOpen: true,
                                                title: `Warning`,
                                                subTitle: <><Box component="div">'{target.text}' has {msg} expired or in soon</Box></>,
                                            })
                                        }
                                    }
                                }
                            }}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            id="editDriver"
                            name="editDriver"
                            options={ddlDriver.filter(v => v.name === props.rowData?.transportId)}
                            value={props.rowData?.driverId ? { text: props.rowData?.driverName, value: props.rowData?.driverId, name: props.rowData?.transportId, hasLine: props.rowData?.hasLine ?? false, driverPhone: props.rowData?.driverPhone, itasId: props.rowData?.itasId } : null}
                            renderOption={option => <><Box component="span" style={{ 'color': 'red' }}>{option?.hasLine ? null : '#'}</Box><Box component="span">{option?.text}</Box><Box component="span">{(option?.driverPhone ? ` (${option.driverPhone})` : '')}</Box></>}
                            renderInput={(params) => <TextField {...params}
                                id="editDriverText"
                                name="editDriverText"
                                label="Driver Name"
                                size="small"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                            />}
                        />
                    );
                },
            },
            {
                field: 'bookTime', title: 'BOOK TIME',
                editComponent: (props) => {
                    return disabledEditing(props.rowData, props.value, 'Book Time') ?? (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container justify="space-around" style={{ width: 130, minWidth: 130, maxWidth: 130 }}>
                                <KeyboardTimePicker
                                    mask="__:__"
                                    disableToolbar
                                    autoOk={true}
                                    size="small"
                                    fullWidth
                                    inputVariant="outlined"
                                    format="HH:mm"
                                    id="editBookTime"
                                    label="Book Time"
                                    value={convertTime2Date(props.value) ?? null}
                                    onChange={(d) => { let v = toStringTime(d); props.onRowDataChange({ ...props.rowData, bookTime: v }) }}
                                    onBlur={e => {
                                        if (e.target.value) {
                                            if (!/(([01][0-9])|(2[0123])):([012345][0-9])/.test(e.target.value)) {
                                                e.target.focus();
                                            }
                                        }
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                        </MuiPickersUtilsProvider>
                    );
                },
            },
            {
                field: 'po', title: 'PO', //render: r => getTooltipData(r.po),
                editComponent: (props) => {
                    return disabledEditing(props.rowData, props.value, 'PO') ?? (
                        <TextField style={{ width: 130, minWidth: 130, maxWidth: 130 }}
                            id="editPO"
                            name="editPO"
                            label="PO"
                            size="small"
                            variant='outlined'
                            onChange={(ev) => props.onRowDataChange({ ...props.rowData, po: ev.target.value })}
                            onBlur={(ev) => props.onRowDataChange({ ...props.rowData, po: ev.target.value })}
                            value={props.value}
                            inputProps={{ maxLength: 50 }}
                            InputLabelProps={{ shrink: true }}
                            />
                    );
                },
            },
            { title: 'QUEUE TIME', editable: 'never', render: (r) => (r.queueTime && r.queueDate ? `${toStringDate(r.queueDate)} ` : '') + (r.fastTrack ? `${r.queueTime ?? ''}/${toStringTime(r.fastTrack)}` : (r.queueTime ?? '')) },
            { title: 'VOLUME', editable: 'never', render: r => `${r.volume} ${r.unit}` },
            { field: 'ticketId', title: 'TICKET ID', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, editable: 'never' },
            { field: 'status', title: 'STATUS', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, editable: 'never' },
        ], [fetchItem, adHocDriver, ddlTruck]);
    
    const readOnlyColumns = useMemo(() =>
        [
            { title: 'CATEGORY', render: r => r.createType === 'IMPORT' || r.createType === 'IMPORT-AUTO' ? `แผนปกติ` : `แผนเพิ่ม` },
            { title: 'DATE', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => toStringDate(r.planDate) },
            { title: 'PRODUCT', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.product, 50) },
            { title: 'CUSTOMER/SUPPLIER', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.customer, 50) },
            { title: 'TRANSPORTER/SUPPLIER', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.transporter, 50) },
            { title: 'VOLUME', render: r => `${r.volume} ${r.unit}`, cellStyle: { width: 300, minWidth: 100, maxWidth: 300 } },
            { title: 'BATCH', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.batch, 50) },
            { title: 'SOURCE', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.source, 50) },
            { title: 'FROM', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.from, 50) },
            { title: 'DESTINATION', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.destination, 50) },
            { title: 'TO', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.to, 50) },
            { title: 'DENSITY', field: 'density', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 } },
            { title: 'DO', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.do, 50) },
            { title: 'SO', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.so, 50) },
            { title: 'PO', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.po, 50) },
            { title: 'REMARK', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.remark, 50) },
            { title: 'DRIVER', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.driverNameWithLine, 50) },
            { title: 'TRUCK NO', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.truckNo, 50) },
            { title: 'BOOK TIME', field: 'bookTime', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 } },
            { title: 'QUEUE DATE', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => toStringDate(r.queueDate) },
            { title: 'QUEUE TIME', render: r => r.fastTrack ? `${r.queueTime}/${toStringTime(r.fastTrack)}` : r.queueTime },
            { title: 'AREA', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.area, 50) },
            { title: 'POINT', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.point, 50) },
            { title: 'ARM', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => getTooltipData(r.arm, 50) },
            { title: 'TICKET ID', field: 'ticketId', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 } },
            { title: 'STATUS', render: r => `${r.status} (${r.state})`, cellStyle: { width: 300, minWidth: 100, maxWidth: 300 } },
            { title: 'MODE', field: 'mode', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 } },
            { title: 'TYPE', field: 'type', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 } },
            { title: 'PLAN', field: 'plan', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 } },
            { title: 'Full Fill Info', cellStyle: { width: 300, minWidth: 100, maxWidth: 300 }, render: r => toStringDate(r.fullFillDate) },
        ], [fetchItem]);

    return (
        <>
            <Container id='containerMR'>

                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        PLANNING
                    </h2>
                </div>

                {/*head*/}
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Card className={classes.root}>
                        <CardContent>
                            <form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <Grid container justify="space-around">
                                                        <KeyboardDatePicker
                                                            disableToolbar
                                                            autoOk={true}
                                                            size="small"
                                                            fullWidth
                                                            inputVariant="outlined"
                                                            format="dd-MMM-yyyy"
                                                            id="planDate"
                                                            label="Date"
                                                            value={convertDate2Date(searchFormData.date)}
                                                            onChange={(d) => handleDateChange(d, 'date', searchFormData, setSearchFormData)}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                        />
                                                    </Grid>
                                                </MuiPickersUtilsProvider>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                                <Autocomplete
                                                    id="searchPlanList"
                                                    name="searchPlantList"
                                                    options={ddlPlant}
                                                    value={searchFormData.plant}
                                                    getOptionLabel={(option) => option?.text}
                                                    renderOption={option => <>{option?.text}</>}
                                                    onChange={(event, newValue) => handleSearchPlantChange(newValue)}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchPlantList"
                                                        name="searchPlantList"
                                                        label="Plant"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                                <Autocomplete
                                                    id="searchProductList"
                                                    name="searchProductList"
                                                    options={ddlProduct}
                                                    value={searchFormData.product}
                                                    getOptionLabel={(option) => option?.text}
                                                    renderOption={option => <>{option?.text}</>}
                                                    onChange={(event, newValue) => handleDdlChange(newValue, 'product', searchFormData, setSearchFormData)}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchProductList"
                                                        name="searchProductList"
                                                        label="Product"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                                <Autocomplete
                                                    id="searchTransportList"
                                                    name="searchTransportList"
                                                    options={ddlTransport}
                                                    value={searchFormData.transport}
                                                    getOptionLabel={(option) => option?.text}
                                                    getOptionSelected={(option, value) => option?.text === value?.text}
                                                    getOptionDisabled={(option) => option?.value === ""}
                                                    renderOption={option => <>{option?.text}</>}
                                                    onChange={(event, newValue) => handleDdlChange(newValue, 'transport', searchFormData, setSearchFormData)}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="searchTransportList"
                                                        name="searchTransportList"
                                                        label="Transport"
                                                        size="small"
                                                        variant="outlined"
                                                    />}
                                                />
                                            </Grid>

                                            <Grid item xs={6} sm={6} md={1} lg={1}>
                                                <Box component="div" className={classes.formFieldContainer} style={{ display: 'flex' }}>
                                                    <InputLabel className={classes.inputLabel} style={{ 'padding-top': '13px' }}>
                                                        Unload:
                                                    </InputLabel>
                                                    <Checkbox
                                                        inputProps={{ "aria-label": "primary checkbox" }}
                                                        name='UNLOAD'
                                                        id='cUnload'
                                                        checked={(searchFormData.type ?? 'UNLOAD') === 'UNLOAD'}
                                                        color='primary'
                                                        onChange={handleSearchTypeChange}
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={6} sm={6} md={1} lg={1}>
                                                <Box component="div" className={classes.formFieldContainer} style={{ display: 'flex' }}>
                                                    <InputLabel className={classes.inputLabel} style={{ 'padding-top': '13px' }}>
                                                        Load:
                                                    </InputLabel>
                                                    <Checkbox
                                                        inputProps={{ "aria-label": "primary checkbox" }}
                                                        name='LOAD'
                                                        id='cLoad'
                                                        checked={(searchFormData.type ?? 'LOAD') === 'LOAD'}
                                                        color='primary'
                                                        onChange={handleSearchTypeChange}
                                                    />
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={2} lg={2}>
                                                <Button style={{ width: '100%' }} variant="contained" onClick={handleSearchSubmit}>Search</Button>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={2}>
                                                <Button style={{ width: '100%' }} variant="contained" onClick={handleSwitchMode} disabled={disabledButtonSwitchMode > 0}>
                                                    {displayMode === 'READ_ONLY' ? 'Plan' : 'Read'} Mode{disabledButtonSwitchMode > 0 ? ` (${disabledButtonSwitchMode})` : ''}
                                                </Button>
                                            </Grid>

                                            {isTransporter ? <Grid item xs={2}></Grid> :
                                                <Grid item xs={2}>
                                                    <Button style={{ width: '100%' }} variant="contained" onClick={handleExportPlan} disabled={exportButton}>Export</Button>
                                                </Grid>
                                            }

                                            {displayMode === 'READ_ONLY' ?
                                                <><Grid item xs={8}></Grid></> :
                                                <>
                                                    {isTransporter ? <Grid item xs={6}></Grid> : <></>}

                                                    <Grid item xs={2}>
                                                        {allowAction(pageCode, "create") ?
                                                            <Button style={{ width: '100%' }} variant="contained" onClick={handleNewDriver}>Add New Driver</Button>
                                                            : <></>}
                                                    </Grid>

                                                    {!isTransporter ?
                                                        <>
                                                            <Grid item xs={2}>
                                                                {allowAction(pageCode, "create") ?
                                                                    <Button style={{ width: '100%' }} color="primary" variant="contained" onClick={handleImportData}>Import</Button>
                                                                    : <></>}
                                                            </Grid>

                                                            <Grid item xs={2}>
                                                                {allowAction(pageCode, "create") ?
                                                                    <Button style={{ width: '100%' }} variant="contained" onClick={handleCreateAction}>Add</Button>
                                                                    : <></>}
                                                            </Grid>

                                                            <Grid item xs={2}>
                                                                {allowAction(pageCode, "delete") ?
                                                                    <Button style={{ width: '100%' }} variant="contained" onClick={handleDeleteSelected} disabled={!(selectedRows && selectedRows.length > 0)}>Delete Selected</Button>
                                                                    : <></>}
                                                            </Grid>
                                                        </> : <></>
                                                    }
                                                </>
                                            }

                                        </Grid>
                                    </Grid>

                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>


                {/*table*/}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {isLargeDisplay && tableData.visibility === 'visible' ?
                        <div className={classes.gridActionsContainer}>
                            <Tooltip
                                title={!containerProps ? 'Expand' : 'Collapse'}
                                open={openTooltip}
                                placement='top'
                            >
                                <IconButton
                                    onMouseEnter={handleShowTooltip}
                                    onMouseLeave={handleHideTooltip}
                                    onClick={() => {
                                        if (!containerProps) {
                                            setContainerProps({ maxWidth: false })
                                        } else {
                                            setContainerProps('')
                                        }
                                        handleHideTooltip()
                                    }
                                    }>
                                    {!containerProps ?
                                        <ArrowExpandHorizontal />
                                        :
                                        <ArrowCollapseHorizontal />
                                    }
                                </IconButton>
                            </Tooltip>
                        </div>
                        :
                        null
                    }

                    <Box px={1.5} visibility={tableData.visibility} className={classes.materialReceivingTable}>
                        <Box component="div" style={{ height: 600, width: "100%" }}>
                            <Box component="span" style={{ color: 'red', fontSize: 'x-small' }}>[# ยังไม่ได้ลงทะเบียน]</Box>
                            {/*{*/}
                            {/*    displayMode === 'READ_ONLY' ?*/}
                            {/*    <MaterialTable*/}
                            {/*        style={{ width: '100%', boxShadow: 'none' }}*/}
                            {/*        //tableRef={tableRef}*/}
                            {/*        icons={TableIcons}*/}
                            {/*        columns={readOnlyColumns}*/}
                            {/*        data={fetchItem}*/}
                            {/*        title=""*/}
                            {/*        options={tableData.options}*/}
                            {/*        components={{*/}
                            {/*            Toolbar: props => (*/}
                            {/*                <Box component="div" style={{ backgroundColor: '#86C1D4', height: '45px' }}>*/}
                            {/*                    <MTableToolbar {...props} />*/}
                            {/*                </Box>*/}
                            {/*            ),*/}
                            {/*        }}*/}
                            {/*    /> :*/}
                            <MaterialTable
                                style={{ width: '100%', boxShadow: 'none' }}
                                //tableRef={tableRef}
                                icons={TableIcons}
                                columns={displayMode === 'READ_ONLY' ? readOnlyColumns : columns}
                                data={fetchItem}
                                title=""
                                options={tableData.options}
                                components={{
                                    Toolbar: props => (
                                        <Box component="div" style={{ backgroundColor: '#86C1D4', height: '45px' }}>
                                            <MTableToolbar {...props} />
                                        </Box>
                                    ),
                                }}
                                actions={displayMode === 'READ_ONLY' ? [] : actions}
                                onSelectionChange={(rows) => setSelectedRows(rows)} //set the selected rows data, prepare for delete
                                //Bulk edit
                                editable={{
                                    onBulkUpdate: changes =>
                                        new Promise(async (resolve, reject) => {
                                            await handleBulkSavePlans(changes, resolve, reject);
                                        }),
                                }}
                            />
                            {/*}*/}

                        </Box>
                    </Box>
                </Grid>

            </Container >


            <Backdrop className={classes.backdrop} open={isLoading} timeout={{ enter: 1100 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {/*New Driver*/}
            <Dialog
                fullWidth={false}
                maxWidth={'lg'}
                open={adHocDriver.isOpen}
                onClose={() => setAdHocDriver({ ...adHocDriver, isOpen: false })}
                aria-labelledby="form-dialog-title">
                <DialogContent id="form-dialog-title" style={{ minHeight: '220px' }}>
                    <Grid container>
                        <Grid item xs={6}>
                            <b>Create One Time Driver</b>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            <HtmlTooltip title={
                                <React.Fragment>
                                    <Typography color="inherit">One Time Driver</Typography>
                                    <span>Partner driver, please create on ITAS</span>
                                </React.Fragment>
                            }>
                                <IconButton aria-label="settings">
                                    <HelpCircleOutline />
                                </IconButton>
                            </HtmlTooltip>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <TextField
                                        id="newDriverName"
                                        name="newDriverName"
                                        label="Name"
                                        className={classes.textField}
                                        variant='outlined'
                                        size="small"
                                        inputProps={{ maxLength: 50 }}
                                        value={adHocDriver.name}
                                        onChange={(ev) => setAdHocDriver({ ...adHocDriver, name: ev.target.value })}
                                        onBlur={(ev) => setAdHocDriver({ ...adHocDriver, name: ev.target.value.trim().length > 2 ? ev.target.value.trim() : '' })}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <TextField
                                        id="newDriverPhone"
                                        name="newDriverPhone"
                                        label="Phone"
                                        className={classes.textField}
                                        variant='outlined'
                                        size="small"
                                        inputProps={{ maxLength: 10 }}
                                        value={adHocDriver.phone}
                                        onChange={(ev) => { if (ev.target.value === '' || /^0[0-9\b]{0,9}$/.test(ev.target.value)) setAdHocDriver({ ...adHocDriver, phone: ev.target.value }); }}
                                        onBlur={(ev) => setAdHocDriver({ ...adHocDriver, phone: (ev.target.value === '' || /^0[1-9\b]{1}[0-9\b]{8}$/.test(ev.target.value)) ? ev.target.value : '' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Autocomplete
                                        id="newDriverTransport"
                                        name="newDriverTransport"
                                        options={ddlTransport}
                                        value={adHocDriver.transport}
                                        getOptionLabel={(option) => option?.text}
                                        getOptionSelected={(option, value) => option?.text === value?.text}
                                        getOptionDisabled={(option) => option?.value === ""}
                                        renderOption={option => <>{option?.text}</>}
                                        onChange={(event, newValue) => setAdHocDriver({ ...adHocDriver, transport: newValue })}
                                        renderInput={(params) => <TextField {...params}
                                            id="newDriverTransportText"
                                            name="newDriverTransportText"
                                            label="Transport"
                                            size="small"
                                            variant="outlined"
                                        />}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <div className={classes.buttonWrapper}>
                        <Button disabled={adHocDriver.isLoading} onClick={handleSaveAdHocDriver} variant="contained" color="primary">Save</Button>
                        {adHocDriver.isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                    <Button onClick={() => setAdHocDriver({ ...adHocDriver, isOpen: false })} variant="contained">Cancel</Button>
                </DialogActions>
            </Dialog>

            {/*Import*/}
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={importFormData.isOpen}
                onClose={() => setImportFormData({ ...importFormData, isOpen: false })}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">

                    <Grid container>
                        <Grid item xs={6}>
                            Import Plan
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            <HtmlTooltip title={
                                <React.Fragment>
                                    <Typography color="inherit">Import data</Typography>
                                    <span>{"Excel data must be separated by a "}</span> <b>{"Tab"}</b> <span>{"(automatically generated with Excel) or a semicolon"}</span> <b>{";"}</b>
                                </React.Fragment>
                            }>
                                <IconButton aria-label="settings">
                                    <HelpCircleOutline />
                                </IconButton>
                            </HtmlTooltip>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6} md={3} lg={3}>
                                    <Autocomplete
                                        id="importPlant"
                                        name="importPlant"
                                        options={ddlPlant}
                                        value={importFormData.plant}
                                        getOptionLabel={(option) => option?.text}
                                        renderOption={option => <>{option?.text}</>}
                                        onChange={(event, newValue) => handleDdlChange(newValue, 'plant', importFormData, setImportFormData)}
                                        renderInput={(params) => <TextField {...params}
                                            id="searchPlantList"
                                            name="searchPlantList"
                                            label="Plant"
                                            size="small"
                                            variant="outlined"
                                        />}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3} lg={3}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <Grid container justify="space-around">
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk={true}
                                                size="small"
                                                fullWidth
                                                inputVariant="outlined"
                                                format="dd-MMM-yyyy"
                                                id="planDate"
                                                label="Date"
                                                value={convertDate2Date(importFormData.date)}
                                                onChange={(d) => handleDateChange(d, 'date', importFormData, setImportFormData)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </Grid>
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginLeft: 16, marginTop: 8 }}>
                                        <FormControl style={{ display: 'flex', flexDirection: 'row' }}>
                                            <FormLabel className={classes.inputLabel}>Type</FormLabel>
                                            <RadioGroup aria-label="importType" name="importType" value={importFormData.type} onChange={(e) => setImportFormData({ ...importFormData, type: e.target.value })} style={{ display: 'flex', flexDirection: 'row', marginLeft: 10, flexWrap: 'nowrap' }}>
                                                <FormControlLabel value="UNLOAD" control={<Radio color='primary' />} label="Unload" />
                                                <FormControlLabel value="LOAD" control={<Radio color='primary' />} label="Load" />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={2} lg={2}>
                                    <Button onClick={handleDownloadTemplate} size='small' variant='contained'>
                                        Download Template
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Box display={Boolean(importFormData.text) ? 'block' : 'none'}>
                        <Typography color="error">You must add some data</Typography>
                    </Box>
                    <TextareaAutosize value={importFormData.text} onChange={event => setImportFormData({ ...importFormData, text: event.target.value })} style={{ width: "100%", whiteSpace: "pre", overflowX: "scroll" }} aria-label="import data" rowsMin={10} placeholder="Copy and paste your data" />
                </DialogContent>
                <DialogActions>
                    <div className={classes.buttonWrapper}>
                        <Button disabled={importFormData.isLoading} onClick={handleImportDataSubmit} variant="contained" color="primary">Import</Button>
                        {importFormData.isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                    <Button onClick={() => setImportFormData({ ...importFormData, isOpen: false })} variant="contained">Cancel</Button>
                </DialogActions>
            </Dialog>

            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    gridActionsContainer: {
        display: 'flex',
        width: '100%',
        height: 32,
        alignItems: 'center',
        justifyContent: 'flex-end',
        backgroundColor: theme.palette.background.paper,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4
    },
    materialReceivingTable: {
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .material-receiving-table.error': {
            backgroundColor: red[100],
            color: red[600],
        },
        '& .material-receiving-table.success': {
            backgroundColor: green[100],
            color: green[600],
        },
        '& .material-receiving-table--header': {
            backgroundColor: '#86C1D4',
            color: 'white',
            fontWeight: 'bold',
        },
        '& svg.MuiSvgIcon-root.MuiDataGrid-iconSeparator': {
            display: 'none'
        }
    },
    table: {
        backgroundColor: theme.palette.background.paper,
    },
    addMaterialReceiving: {
        textAlign: 'center',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
}));